module.exports = __webpack_public_path__ + "img/info_6.d240dc3c.png";